import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from '@material-ui/core';

import { useContent } from 'hooks';
import { Events } from 'analytics';
import { ReactionType, useAddReactionAnalyticsMutation } from 'api';

import { CommentCount } from '../index';
import useStyles from './styles';

const CommentCountModal: FC = () => {
  const classes = useStyles();
  const content = useContent();
  const navigate = useNavigate();

  const { content_id } = content;

  const { mutate: addReactionAnalytics } = useAddReactionAnalyticsMutation();

  function handleReactionAnalytics() {
    addReactionAnalytics({
      content_id,
      reaction_type: ReactionType.Comment,
    });
  }

  function handleOpenToggle() {
    window?.analytics?.track(Events.ClickCommentCount);
    navigate(`/content/${content.content_id}`);
    handleReactionAnalytics();
  }

  return (
    <Link onClick={handleOpenToggle} className={classes.link}>
      <CommentCount />
    </Link>
  );
};

export default CommentCountModal;
